import { render } from "./RoomInfo.vue?vue&type=template&id=f9687cec&scoped=true"
import script from "./RoomInfo.vue?vue&type=script&lang=js"
export * from "./RoomInfo.vue?vue&type=script&lang=js"

import "./RoomInfo.vue?vue&type=style&index=0&id=f9687cec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9687cec"]])

export default __exports__